export const bo_tickets_status_options = [
    {value:'todo', label:'No Action Yet'},
    {value:'jira_added', label:'Jira Added'},
    {value:'in_progress', label:'Jira in Progress'},
    {value:'jira_done', label:'Jira Done'},
    {value:'done', label:'Done'},
    {value:'future_roadmap', label:'Future Roadmap'},
    {value:'not_in_scope', label:'Not in Scope'},
]